import React from 'react';

const CW_LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/64b6f00450a2ccd8585f32418c01e01155b9a46657aed859be5d908803e7074989df043f4ede815d2dc0fa021038408b/images/aW1hZ2UvcG5n/e94f7f44571241bd1a6b36d0f5a35d19.png';
const JELLY_LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/64b6f00450a2ccd8585f32418c01e01155b9a46657aed859be5d908803e7074989df043f4ede815d2dc0fa021038408b/images/aW1hZ2UvanBlZw==/8bc959e50b71ba15f8f48dcf2f7551a3.jpg';

export default function CWHeader() {
  return (
    <header className="cw-header">
      <div className="cw-header-inner">
        <img className="cw-logo" src={CW_LOGO_URL} alt="Cartridge World — The Printer People" />
        <div className="cw-powered-by">
          <span>Powered by Jelly Local</span>
          <img src={JELLY_LOGO_URL} alt="" />
        </div>
      </div>
    </header>
  );
}